export default __webpack_public_path__ + "static/media/archive.fb639d36.svg";